import { axios } from "utils";

import { PUBLIC_IMPERSONATIONS_URL as endpoint } from "consts";

type ExchangeImpersonationCodeResponseBody = {
  token: string;
  farmId: string | null;
};

export const exchangeImpersonationCode = async (data: { code: string }): Promise<ExchangeImpersonationCodeResponseBody> =>
  axios.post(`${endpoint}/exchange`, { data });

export const exitImpersonation = async (): Promise<{ success: boolean }> => axios.post(`${endpoint}/exit`);
